import { Spinner } from "design-react-kit";

const CenteredLoading = () => (
  <div className="d-flex justify-content-center align-items-center h-100">
    <Spinner active />
  </div>
);

export default CenteredLoading;
